import { Box, Typography } from "@mui/material";
import React from "react";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";

const PassengerHistoryItem = ({
  id,
  fullName,
  departure,
  arrival,
  mainContact,
}) => {
  return (
    <Box
      sx={{
        padding: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.5)",
        borderRadius: "6px",
        display: "flex",
      }}
    >
      <Box>
        <CancelScheduleSendIcon sx={{ fontSize: "100px" }} />
      </Box>
      <Box sx={{ width: "100%", paddingLeft: "12px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginBottom: "12px",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>
            {fullName || `Ruta ${id}`}
          </Typography>
        </Box>

        <Box>
          <Typography>{departure || "Departure"}</Typography>
        </Box>
        <Box>
          <Typography>{arrival || "Arrival"}</Typography>
        </Box>
        <Box>
          <Typography>{mainContact || "06x-xxx-xxxx"}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PassengerHistoryItem;
